import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gutter-y-s3 mt-s0" }
const _hoisted_2 = { class: "flex dialog-detail justify-content-between" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "flex gutter-y-s1 flex-column align-items-end" }
const _hoisted_5 = { class: "flex caption" }
const _hoisted_6 = { class: "h2" }
const _hoisted_7 = { class: "flex caption" }
const _hoisted_8 = { class: "flex panel-info-warning justify-content-between" }
const _hoisted_9 = { class: "flex flex-column justify-content-between" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "flex gutter-y-s1 flex-column align-items-end" }
const _hoisted_13 = { class: "flex text-sm opacity-50" }
const _hoisted_14 = { class: "text-right h2 text-default white-space-nowrap" }
const _hoisted_15 = { class: "flex text-sm opacity-50" }
const _hoisted_16 = { class: "caption" }
const _hoisted_17 = { class: "dialog-footer dialog-footer-two-btn" }

import Spinner from '@/components/Spinner.vue';
import { format, printUSDWithCurrency, printLostInUSDWithCurrency } from '@/utils/format';
import BigNumber from 'bignumber.js';
import { BIG_ONE } from '@/utils/bigNumber';
import ExternalLink from '@/components/ExternalLink.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { AutoStaking } from '@/sdk/entities/autoStaking';
import { AUTO_HODL_POOL_LEARN_MORE } from '@/constants/EXTERNAL_LINKS';
import { Rounding } from '@/sdk/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnstakeConfirmation',
  props: {
    amountUsd: null,
    amount: null,
    approve: { type: Boolean },
    inProgress: { type: Boolean },
    token: null,
    cancel: null,
    confirm: null,
    checkTimer: { type: Boolean },
    pool: null
  },
  emits: ["endTimer"],
  setup(__props: any) {

const props = __props as {
  amountUsd: BigNumber;
  amount: string;
  approve?: boolean;
  inProgress?: boolean;
  token: string | '0xf71518D915BB1ff37AF54352a94c0e767b1938aD';
  cancel: () => void;
  confirm: () => void;
  checkTimer: boolean;
  pool: AutoStaking;
}





const { t } = useI18n();
const { ROUND_UP } = Rounding;
const recievedBlues = computed(() => {
  const bigAmount = new BigNumber(props.amount);
  return props.checkTimer
    ? bigAmount.multipliedBy(
        BIG_ONE.minus(props.pool.withdrawFee?.dividedBy(props.pool.divisor).multipliedBy(100)),
      )
    : props.amount;
});
const recievedUSD = computed(() => {
  return props.pool.calculateUSD(recievedBlues.value.toString());
});

const percentOfAvailableCompound = computed(() => {
  return new BigNumber(props.amount).dividedBy(props.pool.printAvailableCompound).multipliedBy(100);
});
const lostBlues = computed(() => {
  return props.pool.printTotalCompound
    .minus(props.pool.printAvailableCompound)
    .multipliedBy(percentOfAvailableCompound.value)
    .dividedBy(100);
});
const lostUSD = computed(() => {
  return props.pool.calculateUSD(lostBlues.value.toString());
});
const percentOfLockedReward = computed(() => {
  return new BigNumber(props.amount).dividedBy(props.pool.printAvailableCompound).multipliedBy(100);
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('yieldPool.unstakeConfirmDialog.youReceive')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(format)(_unref(percentOfAvailableCompound).toFixed(2, _unref(ROUND_UP)))) + "% " + _toDisplayString(_unref(t)('yieldPool.unstakeConfirmDialog.ofAvailableCompound')), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)(_unref(recievedBlues))) + " BLUES", 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(printUSDWithCurrency)(_unref(recievedUSD), 'USD')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('yieldPool.unstakeConfirmDialog.youLose')) + " *", 1),
            _createElementVNode("div", {
              class: "text-sm opacity-50",
              innerHTML: _unref(t)('yieldPool.unstakeConfirmDialog.youLoseComment')
            }, null, 8, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(format)(_unref(percentOfLockedReward).toFixed(2, _unref(ROUND_UP)))) + "% " + _toDisplayString(_unref(t)('yieldPool.unstakeConfirmDialog.ofLockedReward')), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(format)(_unref(lostBlues))) + " BLUES ", 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(printLostInUSDWithCurrency)(_unref(lostUSD), 'USD')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, "* " + _toDisplayString(_unref(t)('yieldPool.unstakeConfirmDialog.autoPoolDescription')), 1),
      _createElementVNode("div", null, [
        _createVNode(ExternalLink, {
          label: _ctx.$t('learnMore'),
          color: "primary",
          url: _unref(AUTO_HODL_POOL_LEARN_MORE),
          class: "text-sm"
        }, null, 8, ["label", "url"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _unref(t)('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.cancel()))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('yieldPool.unstakeConfirmDialog.confirmBtn'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.confirm())),
        disabled: __props.inProgress
      }, {
        default: _withCtx(() => [
          (__props.inProgress)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                color: "white",
                size: "24",
                class: "mr-s2"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)('yieldPool.unstakeConfirmDialog.confirmBtn')), 1)
        ]),
        _: 1
      }, 8, ["label", "disabled"])
    ])
  ], 64))
}
}

})